/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Fond_Deep_Seal_LandInputs */

const en_fond_deep_seal_land = /** @type {(inputs: Fond_Deep_Seal_LandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shared Segments (${i?.count})`)
};

const de_fond_deep_seal_land = /** @type {(inputs: Fond_Deep_Seal_LandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Direkt freigegebene Segmente (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Shared Segments ({count})" |
*
* @param {Fond_Deep_Seal_LandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fond_deep_seal_land = /** @type {((inputs: Fond_Deep_Seal_LandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fond_Deep_Seal_LandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fond_deep_seal_land(inputs)
	return de_fond_deep_seal_land(inputs)
});